import React, { useEffect, useState } from 'react';
import { Modal, Input, Select, Button } from 'antd';
import { formateCoins } from '../../../../function';
import { getAllVentes, confirmAchat } from '../../../../services/achat/admnAchatApi';
import { toast } from 'react-toastify';
import { ModalFooter } from 'react-bootstrap';

const ConfirmAchat = ({ isOpen, onClose, achat,onSuccess }) => {
    const [ventes, setVentes] = useState([]);
    const [reglements, setReglements] = useState([{ montant: 0, vente_id: '' }]);

    const fetchVentes = async () => {
        const response = await getAllVentes();
        setVentes(response);
    }

    useEffect(() => {
        fetchVentes();
    }, [achat, isOpen]);


    const handleConfirmAchat = async () => {

        if (reglements.length === 0) {
            toast.error('Veuillez ajouter un reglement');
            return;
        }
        if (reglements.some(reglement => reglement.vente_id === '')) {
            toast.error('Veuillez sélectionner une vente');
            return;
        }
        if (reglements.some(reglement => reglement.montant === 0)) {
            toast.error('Veuillez sélectionner une vente');
            return;
        }
        if (totalMontant !== achat.offre.coins / 1000) {
            toast.error('Le total des reglements ne correspond pas au montant de l\'offre');
            return;
        }
        const reglementsData = reglements.map(reglement => ({
            montant: reglement.montant * 1000,
            vente_id: reglement.vente_id
        }));
        const response = await confirmAchat(reglementsData, achat.id).then(res => {
            toast.success('Achat confirmé avec succès');
            onClose();
            onSuccess();

        }).catch(err => {
            toast.error(err.response.data.message);
        })
    }
    const handleAddReglement = () => {
        setReglements([...reglements, { montant: 0, vente_id: '' }]);
    };

    const handleReglementChange = (index, field, value) => {
        const newReglements = [...reglements];
        newReglements[index][field] = value;
        setReglements(newReglements);
    };

    const handleDeleteReglement = (index) => {
        const newReglements = reglements.filter((_, i) => i !== index);
        setReglements(newReglements);
    };

    const totalMontant = reglements.reduce((total, reglement) => total + Number(reglement.montant), 0);

    return (
        <Modal
            title="Backup Codes"
            visible={isOpen}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <div className="row">
                <div className="col-md-6">
                    <Input className='m-2' value={formateCoins(achat?.offre?.coins) + " coins"} disabled />
                </div>
                <div className="col-md-6">
                    <Input className='m-2' value={`Total Montant: ${formateCoins(totalMontant * 1000)} coins`} disabled />
                </div>

            </div>
            <hr />
            <div className='row m-2'>

                {reglements.map((reglement, index) => (
                    <>
                        <div key={index} className="col-lg-6">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control mb-4"
                                    value={reglement.montant}
                                    onChange={(e) => handleReglementChange(index, 'montant', e.target.value)}
                                    placeholder="Enter montant"
                                    style={{ backgroundColor: 'var(--input-bg) !important' }}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text" style={{ backgroundColor: 'var(--input-bg) !important' }}>K</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='d-flex'>
                                <Select
                                    className='m-2 '
                                    value={reglement.vente_id}
                                    onChange={(value) => handleReglementChange(index, 'vente_id', value)}
                                    style={{ width: '100%' }}
                                >
                                    <Select.Option value="">Select Vente</Select.Option>
                                    {ventes.map(vente => (
                                        <Select.Option key={vente.id} value={vente.id}>{`${formateCoins(vente.coins)} coins | ${vente.utilisateur.username} | ${vente.date_vente}`}</Select.Option>
                                    ))}
                                </Select>
                                <button
                                    className='my-2  p-0 pt-3'
                                    onClick={() => handleDeleteReglement(index)}
                                    style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                                    width={20}
                                >
                                    <span role="img" aria-label="delete">❌</span>
                                </button>
                            </div>
                        </div>
                    </>
                ))}
            </div>
            <div className="col-md-12">

                <button className='m-2' onClick={handleAddReglement}>Add Another Reglement</button>
            </div>
            <ModalFooter>
                <button className='m-2' style={{ background: 'red !important' }} onClick={onClose}>Cancel</button>
                <button className='m-2' style={{ backgroundColor: '#21E786 !important' }} onClick={handleConfirmAchat}>Confirm</button>
            </ModalFooter>
        </Modal >
    );
};

export default ConfirmAchat;